import { MobileOutlined, DesktopOutlined } from "@ant-design/icons";

// configuração dos tipos de upload por tela
  export const uploadConfig = {
    activity_screen: [
      {
        id: "desktop",
        text: "Desktop",
        icon: DesktopOutlined,
      },
      {
        id: "desktop_full",
        text: "Desktop Full",
        icon: DesktopOutlined,
      },
      { id: "tablet", text: "Tablet", icon: MobileOutlined },
      { id: "mobile", text: "Mobile", icon: MobileOutlined },
    ],
    panel: [
      {
        id: "desktop_mobile",
        text: "Desktop e Mobile",
        icon: DesktopOutlined,
      },
    ],
  };